module.exports = __webpack_public_path__ + "static/media/defaultImage.931ffdbb.jpeg";